import styled from 'styled-components'

export const CenteredComponentContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1; /* Above the blurred background */
`
